export default [
  [0.1125, 0.1388, 0.2625, 0.3500, 0.3500, 0.3500, 0.3500],
  [0.1500, 0.1850, 0.3500, 0.3500, 0.3500, 0.3500, 0.3500],
  [0.1600, 0.2500, 0.3750, 0.3500, 0.3500, 0.3500, 0.3500],
  [0.1700, 0.2000, 0.3750, 0.3500, 0.3500, 0.3500, 0.3500],
  [0.2500, 0.2000, 0.3750, 0.3500, 0.3500, 0.3500, 0.3500],
  [0.2750, 0.2000, 0.3750, 0.3500, 0.3500, 0.3500, 0.3500],
  [0.3000, 0.2000, 0.3750, 0.3500, 0.3500, 0.3500, 0.3500],
] as const;
